import axiosServicesOnboarding from "../../../services/axiosServicesOnboarding";
import api, { formApi, walletApi } from "../api";

const FundingModule = () => {
  return {
    // https://wallet-dev.flexmonie.com/v1/api/Transaction/banks
    // https://wallet-dev.flexmonie.com/v1/api/Transaction/banks
    // https://wallet-dev.flexmonie.com/v1/api/Transaction/banks

    GetBanks: function () {
      return walletApi.get("Transaction/banks");
    },

    ViewAllWallet: function (data) {
      return axiosServicesOnboarding.get("Agent/Wallet/all");
    },

    TransferToBank: function (data) {
      return walletApi.post("Transaction/transfer-to-bank", data);
    },

    // ***********************************************************************************************************************************************************************************************

    BulkUploadAgent: function (data) {
      return formApi.post("identity/Agent/uploadagents", data);
    },

    // /Agent/reseller/onboardagent
    FundingCustomers: function (data) {
      return api.post("wallet/Wallet/wallettransfer", data);
    },
  };
};

export const FundingService = {
  FundingModule: FundingModule,
};
